module.exports = __webpack_public_path__ + "img/banner_back.b218581f.png";